export default "__VITE_PUBLIC_ASSET__a92b619b__"